import * as React from 'react';
import { EXTRA_SMALL_ICON_BASE_SRC } from '../../../../Shared';
import {
  ClassroomLesson,
  Question
} from '../../../interfaces/classroomLessons';
import {
  ClassroomLessonSession
} from '../interfaces';
import ScriptComponent from '../shared/scriptComponent';
import { sortByLastName } from '../shared/studentSorts';

const checkCircleIcon = `${EXTRA_SMALL_ICON_BASE_SRC}/check-color.svg`
const clearIcon = `${EXTRA_SMALL_ICON_BASE_SRC}/clear-enabled.svg`

interface LobbyProps {
  data: ClassroomLessonSession,
  slideData: Question,
  lessonData: ClassroomLesson,
  nextSlideButton?: React.ReactNode
}

interface LobbyState {}

class Lobby extends React.Component<LobbyProps, LobbyState> {
  constructor(props) {
    super(props);
  }

  renderPresentStudents(presence, students) {
    if (!students) { return null }

    const sortedKeys = Object.keys(students).sort((key1, key2) => {
      return sortByLastName(key1, key2, students);
    })

    return sortedKeys.map((key) => {
      const name = students[key];
      const online = presence && presence[key];
      return (
        <li key={name}>
          <p className="student-name">{name}</p>
          <span className="student-status">
            {online
              ? <img alt="Online" className="status-icon status-online" src={checkCircleIcon} />
              : <img alt="Not joined" className="status-icon status-offline" src={clearIcon} />}
          </span>
        </li>
      );
    });
  };

  renderNumberPresentStudents(presence, students) {
    const numTotal = students ? Object.keys(students).length : 0;
    const numPresent = presence ? Object.keys(presence).length : 0;
    return (
      <p>
        <strong>{numPresent} of {numTotal} student{numTotal === 1 ? '' : 's'}</strong> joined
      </p>
    );
  }

  // This returns static data for now
  renderHeader() {
    return (
      <div className="lobby-header">
        <p className="unit-title">Lessons Pack: {this.props.lessonData.unit}</p>
        <p className="lesson-title"><span>Lesson {this.props.lessonData.lesson}:</span> {this.props.lessonData.topic}</p>
      </div>
    )
  }

  renderScript() {
    return (<ScriptComponent script={this.props.slideData.data.teach.script} />)
  }

  renderPresence() {
    return (
      <div className="presence-container">
        <div className="presence-header">
          {this.renderNumberPresentStudents(this.props.data.presence, this.props.data.students)}
        </div>
        <div className="presence-list-container">
          <div className="presence-list-titles"><span className="student-name">Student</span><span className="student-status">Status</span></div>
          <ul>
            {this.renderPresentStudents(this.props.data.presence, this.props.data.students)}
          </ul>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="teacher-lobby">
        {this.renderHeader()}
        <div className="lobby-body">
          <div className="lobby-left">
            {this.renderScript()}
            {this.props.nextSlideButton && (
              <div className="lobby-next-button-wrapper">
                {this.props.nextSlideButton}
              </div>
            )}
          </div>
          {this.renderPresence()}
        </div>
      </div>
    );
  }

}

export default Lobby;
